<div class="custom-slide-toggle"
     matTooltipPosition="above"
     [matTooltip]="tooltipDescription"
     (click)="!disabled && onToggle()"
     [class.disabled]="disabled">
    <span class="slider"
          [class.active]="value"
          [class.accent]="color === 'accent'"
          [class.primary]="color === 'primary'"
          [class.error]="color === 'error'"
          [class.success]="color === 'success'"
          [class.disabled]="disabled"
          [class.on_off]="color === 'on-off'"
    ></span>
</div>
<label *ngIf="label" (click)="!disabled && onToggle()" [class.disabled]="disabled">{{ label }}</label>
